import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiListDataService} from './api.list-data.service';
import {ClientModel} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ApiClientService extends ApiListDataService<ClientModel, ClientModel> {

  constructor(http: HttpClient) {
    super(http, '/Client/');
  }
}
